import { appStore } from '@/store';
import { getLocale } from '@/lib/globals';

import { fetchAddressesFromPostalCode } from './api';
import { constructAddressAutoPopulationPayload } from './mapper';
import {
  getAddressMetaFromId,
  getFieldData,
  logBlurOrFocusEvent,
} from '../../Form/utils';

export const blurHandler = e => {
  logBlurOrFocusEvent(e);

  const { id } = e.target;
  const meta = getAddressMetaFromId(id);
  const { addressType } = getFieldData(e.target, meta);

  const { form: formState } = appStore.getState();
  const country =
    addressType === 'shipping'
      ? formState.shippingAddress.country.value
      : getLocale().country;

  fetchAddressesFromPostalCode({ addressType, country }).then(res => {
    if (!res.data?.addressNormalization?.line1) {
      return;
    }

    const result = res.data.addressNormalization;
    const payload = constructAddressAutoPopulationPayload(result);

    const { form: formActions } = appStore.getActions();

    formActions.updateAllAddressFieldsUsingANS({
      addressType,
      isBatchUpdate: true,
      payload,
    });
  });
};
